module.exports = __webpack_public_path__ + "img/background_8.b9a44de4.jpg";